export function truncate(string) {
  return string.length > 9 ? string.substring(0, 9) + "..." : string;
}
